import { memo } from "react"
import { useSearchParams } from "react-router-dom";
import { ADMIN_URL } from "~/config/config";

const AuthController = () => {
  {
    const [searchParams, setSearchParams] = useSearchParams();

    const jwt = searchParams.get('jwt')
    if (jwt) {
      localStorage.setItem('jwt', jwt)
    }

    // List of public routes that don't require authentication
    const publicRoutes = ['/', '/transfer', '/login'];
    const currentPath = window.location.pathname;

    if (!localStorage.getItem('jwt') && !publicRoutes.includes(currentPath)) {
      window.location.href = `/login?goto=${encodeURIComponent(window.location.href)}`
    }
  }

  return <></>
}

export default memo(AuthController);